module.exports = {
	"Announcement": {
		"Know More": "Más información"
	},
	"Appointment": {
		"Conditions": "Haciendo clic en “Confirmar“, confirma haber leído la Política de Privacidad y acepta que sus datos personales sean objeto de tratamiento por parte de %(brand)s según las condiciones establecidas en la Política de Privacidad para responder a su solicitud.",
		"Confirmation": "Hemos tenido en cuenta su solicitud de cita en una boutique con uno de nuestros asesores para una asistencia personalizada. Le enviaremos un correo electrónico de confirmación próximamente.",
		"Description": "Dior le invita a solicitar una cita con un asesor en una boutique para beneficiarse de una ayuda personalizada.",
		"Get an appointment": "Solicitar una cita",
		"Motives": "Motivos",
		"Universes": "Universo"
	},
	"DiorMap": {
		"Search in this area": "Buscar en esta zona"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Resultado",
			"other": "%(count)s Resultados",
			"zero": "%(count)s Resultado"
		},
		"Refine": "Refinar",
		"RefineAria": "Mejore la búsqueda con las siguientes casillas de verificación",
		"Are you looking for?": "¿Busca una boutique de Moda Mujer, Moda Hombre, Bebé, Joyería o Relojería?"
	},
	"Footer": {
		"Download the applications": "Descargar las aplicaciones",
		"Language": "Idioma",
		"Newsletter": "Ej.: Christian@dior.fr",
		"Ok": "Aceptar",
		"Subscribe to newsletter": "Suscribirse a la Newsletter"
	},
	"Form": {
		"All fields are mandatory": "Todos los campos son obligatorios",
		"Civility": "Tratamiento",
		"Comments": "Comentarios",
		"Conditions": "Si desea recibir una confirmación por correo electrónico por parte de %(brand)s, active la opción a continuación. Usted tiene derecho a acceder, rectificar y suprimir los datos que le conciernen, y a oponerse a que se procesen. Podrá ejercer este derecho escribiendo a la siguiente dirección: contactdior@dior.com.",
		"Date": "Fecha deseada ",
		"Email": "Correo electrónico",
		"Hour": "Horarios deseados",
		"Invalid E-mail address": "Dirección de correo electrónico no válida",
		"Mr": "Sr.",
		"Mrs": "Sra.",
		"Name": "Apellido(s)",
		"Phone": "Teléfono",
		"Required fields": "Campos requeridos",
		"Submit": "Validar",
		"Surname": "Nombre"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Boutiques Dior en su ciudad: alta costura, perfumería, marroquinería",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Llegada",
		"Departure": "Salida",
		"Details": "Detalles",
		"Error": "Lo sentimos, no hemos podido encontrar el itinerario solicitado. Modifique la dirección de salida y/o el medio de transporte utilizado e inténtelo de nuevo",
		"Follow the itinerary": "Seguir el itinerario",
		"Itinerary": "Itinerario",
		"modeBICYCLING": "En bicicleta",
		"modeDRIVING": "En coche",
		"modeTRANSIT": "En transporte público",
		"modeWALKING": "A pie",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Por favor usa tu teléfono en modo vertical"
	},
	"NavMobile": {
		"Home": "Inicio"
	},
	"Newsletter": {
		"Dior Newsletter": "Newsletter Dior",
		"Fashion and accessories": "Moda y Accesorios",
		"I wish to receive the %(newsletter)s newsletter": "Deseo recibir las últimas noticias %(newsletter)s",
		"Newsletter Confirmation": "Se ha suscrito a la newsletter",
		"Perfume and beauty": "Perfume y Belleza",
		"Receive our newsletter": "Reciba nuestra newsletter",
		"Your universes": "Sus universos"
	},
	"ResultsBlock": {
		"Dior boutiques": "Boutiques Dior",
		"Too far": "Demasiados resultados, mejore su búsqueda seleccionando una zona de.",
		"No result": "No se ha encontrado ninguna boutique",
		"Other shops": "Otras boutiques",
		"Results": "Resultados de búsqueda",
		"Fewer results, zoom in": "Menos resultados, zoom in",
		"More results, zoom out": "Más resultados, zoom out",
		"Fewer results": "Menos resultados",
		"More results": "Más resultados"
	},
	"SearchBlock": {
		"Geolocation": "Active la ubicación para encontrar su boutique más cercana",
		"Search": "Buscar"
	},
	"Share": {
		"Conditions": "Haciendo clic en “Confirmar“, afirma haber leído la Política de Privacidad y acepta que sus datos personales sean objeto de tratamiento por parte de %(brand)s según las condiciones establecidas en la Política de Privacidad para responder a su solicitud. Si marca la casilla correspondiente, da su consentimiento para que sus datos personales sean objeto de tratamiento por parte de Christian Dior Couture para marketing directo, que puede adecuarse basándose en sus datos personales y en sus preferencias.",
		"Recipient": "Su destinatario",
		"Share Confirmation": "La ficha de su boutique se envió correctamente",
		"Share this shop": "Compartir la ficha de la boutique",
		"Your favorite shop": "Su boutique preferida"
	},
	"ShopBlock": {
		"Closed": "Cerrada",
		"Closed today": "Cerrado hoy",
		"Directions": "Itinerario",
		"DirectionsAria": "Indicaciones hacia %(shopName)s",
		"Make an appointment": "Solicitar una cita",
		"Open": "Abierto",
		"Opening time": "Horarios de apertura",
		"OpeningAria": "Más información en Horarios de apertura",
		"ResultNumber": "Resultado numero %(number)s",
		"Services": "Servicios",
		"ServicesAria": "Más información en Servicios",
		"Share": "Compartir",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Hoy hasta las %(hour)s",
		"Universes": "Universo",
		"UniversesAria": "Más información en los Universos relacionados",
		"and": "and",
		"from": "from",
		"publicHolidays": "Es posible que la boutique esté cerrada",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/es_es/translations.json
// module id = 862
// module chunks = 0